import React, { useState } from 'react';
import Modal from "react-modal";

export default function CustomModal({ title, description, isOpen, onClose, children, size = 'small', hideCloseButton = false }) {
    if (!isOpen) {
        return null;
    }

    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            maxWidth: '90%',
            width: size === 'large' ? 'auto' : '600px',
            minWidth: '400px',
            borderRadius: 0,
            transform: 'translate(-50%, -50%)',
            border: '1px solid #8B8B8B',
            padding: '12px 20px 20px'
        },
        overlay: {
            zIndex: 10,
            overflow: 'hidden'
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            // onAfterOpen={afterOpenModal}
            onRequestClose={onClose}
            style={customStyles}
            contentLabel={title}
            shouldCloseOnOverlayClick={!hideCloseButton} 
            appElement={document.querySelector(".ReactModalPortal")}
        >
            <div className="position-relative">
                {
                    !hideCloseButton && <button
                        className="modal__close-button"
                        onClick={onClose}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
                            <path d="M31 19L19 31" stroke="#757575" strokeWidth="1.5" strokeLinecap="round"
                                  strokeLinejoin="round"/>
                            <path d="M19 19L31 31" stroke="#757575" strokeWidth="1.5" strokeLinecap="round"
                                  strokeLinejoin="round"/>
                        </svg>
                        {/*{translate('modal.close')}*/}
                    </button>
                }

                <div>
                    {
                        title && <p className="modal__title">{title}</p>
                    }

                    {
                        description && <p>{description}</p>
                    }

                    {children}
                </div>
            </div>
        </Modal>
    )
}
